import React from 'react'

import SvgIcon from './svgIcon'

const data = {
  id: 'instagram',
  viewBox: '0 0 24 24',
  children: [
    {
      name: 'path',
      transform: 'translate(-618.098 -772.174)',
      d: 'M630.1,774.336c3.2,0,3.583.013,4.849.07a6.634,6.634,0,0,1,2.227.413,3.972,3.972,0,0,1,2.278,2.277,6.623,6.623,0,0,1,.413,2.228c.058,1.265.07,1.645.07,4.849s-.012,3.583-.07,4.849a6.623,6.623,0,0,1-.413,2.228,3.974,3.974,0,0,1-2.278,2.277,6.615,6.615,0,0,1-2.227.413c-1.266.058-1.645.07-4.849.07s-3.584-.012-4.849-.07a6.621,6.621,0,0,1-2.228-.413,3.973,3.973,0,0,1-2.278-2.277,6.646,6.646,0,0,1-.413-2.228c-.057-1.266-.07-1.645-.07-4.849s.012-3.584.07-4.849a6.647,6.647,0,0,1,.413-2.228,3.972,3.972,0,0,1,2.278-2.277,6.64,6.64,0,0,1,2.228-.413c1.265-.057,1.645-.07,4.849-.07m0-2.162c-3.259,0-3.667.013-4.948.072a8.81,8.81,0,0,0-2.913.558,6.139,6.139,0,0,0-3.509,3.509,8.809,8.809,0,0,0-.558,2.913c-.058,1.28-.072,1.688-.072,4.948s.013,3.667.072,4.948a8.8,8.8,0,0,0,.558,2.912,6.137,6.137,0,0,0,3.509,3.51,8.812,8.812,0,0,0,2.913.557c1.28.058,1.688.073,4.948.073s3.667-.014,4.948-.073a8.808,8.808,0,0,0,2.913-.557,6.135,6.135,0,0,0,3.51-3.51,8.805,8.805,0,0,0,.557-2.912c.058-1.28.073-1.688.073-4.948s-.014-3.667-.073-4.948a8.811,8.811,0,0,0-.557-2.913,6.137,6.137,0,0,0-3.51-3.509,8.805,8.805,0,0,0-2.913-.558c-1.28-.058-1.688-.072-4.948-.072Z',
    },
    {
      name: 'path',
      transform: 'translate(-619.594 -773.67)',
      d: 'M631.594,779.179a6.491,6.491,0,1,0,6.49,6.491A6.492,6.492,0,0,0,631.594,779.179Zm0,10.7a4.213,4.213,0,1,1,4.213-4.214A4.214,4.214,0,0,1,631.594,789.884Z',
    },
    {
      name: 'circle',
      cx: '1.359',
      cy: '1.359',
      r: '1.359',
      transform: 'translate(17.096 4.186)',
    },
  ],
}

const Icon = (props) => {
  return (
    <SvgIcon
      {...props}
      data={data}
    />
  )
}

export default Icon
